import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { nodesAtom } from "../nodes";

export const hasVisibleAnnotationAtomFamily = atomFamily((nodeId: string) => {
  const a = atom((get) => {
    const nodes = get(nodesAtom);
    return nodes.some(
      (node) =>
        node.type === "annotation" && node.parentId === nodeId && !node.hidden,
    );
  });
  a.debugLabel = `hasVisibleAnnotationAtomFamily(${nodeId})`;
  return a;
});
